import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { BDSMForm } from '../../../../components/form/BDSMForm';

export const DynamicQuantity = ({ onClick, selection }) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation('recipe');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getCursorIndex = (cursor) => {
        return cursor != null
        && cursor.anchorNode != null
        && cursor.anchorNode.nodeName === '#text'
        && cursor.anchorNode.parentElement.id === 'editable-content'
            ? cursor.anchorOffset
            : null;
    };
    const cursorIndex = getCursorIndex(selection);
    let textNode = cursorIndex != null ? selection.anchorNode.nodeValue : null;

    const validation = Yup.object().shape({
        quantity: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01),
    });

    const handleSave = (values) => {
        let result = {
            ...values,
            cursorIndex: cursorIndex,
            text: textNode,
        };
        onClick(result);
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: { quantity: 0 },
            onSubmit: (record) => handleSave(record),
            onCancel: () => handleClose(),
            validationSchema: validation,
            fieldNames: ['quantity'],
            types: ['number'],
            className: 'mb-3',
            label: [t('dynamicQuantity.quantity')],
            selectData: [null],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <Button
                type='submit'
                variant='success'
                className={'button dynamic-quantity'}
                onClick={handleShow}>
                {t('dynamicQuantity.button')}
            </Button>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('dynamicQuantity.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};